export default "__VITE_ASSET__D5Eu6oBU__"